import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { WebWorkerService } from "angular2-web-worker/web-worker.service";
import { Ng2DatetimePickerModule } from 'ng2-datetime-picker';

import { SharedModule } from '../shared/shared.module';
import { DashboardAdminComponent } from './dashboard-admin.component';
import { DashboardSharedModule } from "./dashboard-shared.module";
import { DashBoardAdminService } from './dashboard-admin.service';
import { DateHelperService, NumberFormatService } from '../core/services';
import { DashboardAdminStyleService } from "./dashboard-admin-style.service";
import { TrafficComponent, RevenueBySourceComponent, FillBySourceComponent, TodaysTopCampaignViewsComponent, TopFillBySourceComponent, ListComponent } from "./dashboard-admin.index";
import { FillBySourceService } from "./fillbysource/fill-by-source.service";
import { TopFillBySourceService } from "./topfillbysource/top-fill-by-source.service";

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        Ng2DatetimePickerModule,
        DashboardSharedModule
    ],
    declarations: [
        DashboardAdminComponent,
        TrafficComponent,
        RevenueBySourceComponent,
        TodaysTopCampaignViewsComponent,
        FillBySourceComponent,
        TopFillBySourceComponent,
        ListComponent
        ],
    providers: [
        DashBoardAdminService,
        DatePipe,
        DateHelperService,
        DecimalPipe,
        NumberFormatService,
        FillBySourceService,
        TopFillBySourceService,
        DashboardAdminStyleService,
        WebWorkerService],
})
export class DashboardAdminModule { }



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard-admin.module.ts